const baseUrl = process.env.NEXT_PUBLIC_BASE_URL

export const sendNewsletterForm = async ({ userId = null, email, lang, fbclid }) => {
    const data = {
        userId,
        email,
        lang,
        fbclid,
    }

    const url = `${baseUrl}/enquiry/newsletter`

    const headers = {
        'apikey': process.env.NEXT_PUBLIC_RSTBASE_API_KEY,
        'Content-Type': 'application/json'
    }

    const response = await fetch(url, {
        method: 'POST',
        headers: headers,
        cache: 'no-store',
        body: JSON.stringify(data)
    })

    // Don't blow up on an empty / non-JSON body (e.g. a 204 or an HTML error page)
    let result = null
    try { result = await response.json() } catch { result = null }

    if (!response.ok) {
        const err = new Error(result?.message ?? `Newsletter signup failed (${response.status})`)
        err.status = response.status
        err.result = result
        throw err
    }

    return result
}